import {
    GETROLELLIST_SUCCESS,
    GETROLELLIST_FAILED,
    RESET_GETROLELLIST,
    LOADING_GETROLELLIST,
    NETWORK_ERROR_GETROLELLIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetRoleList = () => {
    return { type: RESET_GETROLELLIST };
};

const getRoleList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETROLELLIST });
    await adminServices
        .post("getRoleList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getRoleListsuccess(res.data));
                    break;
                default:
                    dispatch(getRoleListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETROLELLIST, payload: err });
        });
};
function getRoleListsuccess(data) {
    return {
        type: GETROLELLIST_SUCCESS,
        payload: data,
    };
}
function getRoleListFailed(data) {
    return {
        type: GETROLELLIST_FAILED,
        payload: data,
    };
}

export { resetGetRoleList, getRoleList };
